import OrderPage from '../order/page';

export default function Home() {
  return <OrderPage />;
}